import { CreateEmptyFirestoreDocParams } from '../types/Chart/CreateEmptyFirestoreDocParams';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../constants/firebaseModular';

export const createEmptyFirestoreDoc = async (payload: CreateEmptyFirestoreDocParams) => {
  let data = {};
  const docRef = doc(db, 'users', payload.patientId, 'Chart', payload.title);
  if (payload.title === 'PATIENT_SIGNATURE') {
    data = {
      signature1DataURI: '',
    };
  }
  if (payload.title === 'WITNESS_SIGNATURE') {
    data = {
      signature1DataURI: '',
      witnessName: '',
      witnessEmail: '',
      signature2DataURI: '',
      witness2Name: '',
      witness2Email: '',
    };
  }
  return await setDoc(docRef, data);
};
